import Swiper from "swiper"
import { EffectFade, Autoplay } from "swiper/modules"

import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/effect-fade"

class SmvCarousel extends HTMLElement {

  constructor() {
    super();
  }


  connectedCallback() {
    const slides = this.querySelectorAll('.swiper-slide');

    // Check if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (slides.length > 1) {
      const swiper = new Swiper(this.querySelector('.swiper'), {
        modules: [EffectFade, Autoplay],
        effect: "fade",
        slidesPerView: 1,
        fadeEffect: { crossFade: true },
        // loop: true,
        speed: 1200,
        allowTouchMove: false,
        autoplay: prefersReducedMotion ? false : {
          delay: 2000,
          disableOnInteraction: false,
        },
      });
    }
  }

}

// Define the new web component
if ('customElements' in window) {
  customElements.define('smv-carousel', SmvCarousel);
}
